<template>
  <section class="section">
    <h-context-header
      v-if="showHeader"
      learnMoreLink="/webapps"
      :isExternalLink="false"
      class="list-view-context-header"
      @closed="closeHeader"
    >
      <template v-slot:title>What is a Space?</template>
      <template v-slot:description
        >Spaces are like a 3D document. You start by picking from an
        ever-growing library of templates, like Hangar, Beach, Classroom, or
        Blank Slate. Then, you can add and arrange pictures, videos, text,
        audio, web apps, or 3D models within the Space. Spaces can be used for
        hosting training modules, collaborative design reviews, and more. You
        can publish Spaces to the public Holos Library or keep them private for
        just you and your friends or co-workers.
      </template>
    </h-context-header>
    <h-spaces-card-container>
      <div v-for="(space, index) in spaces" :key="space.id">
        <h-spaces-card
          :popUp="false"
          :hoverShadow="true"
          :content="space"
          :width="`220px`"
          :hasText="true"
          :hasBadge="true"
          :flip="true"
          :index="index"
        />
      </div>
    </h-spaces-card-container>
  </section>
</template>

<script>
import HSpacesCard from "@/components/spaces/HSpacesCard";
import HSpacesCardContainer from "@/components/spaces/HSpacesCardContainer";
import { mixins } from "@/common/mixins.service";

export default {
  name: "spaces-list",
  components: { HSpacesCard, HSpacesCardContainer },
  mixins: [mixins.contextHeader("SpacesListContextHeader")],
  data() {
    return {
      spaces: undefined,
    };
  },
  created() {
    this.spaces = this.$route.meta.data;
  },
};
</script>

<style scoped></style>
